import useCustomNavigate from 'hooks/useCustomeNavigate';
import showToast from 'utils/toast';
import type { IWorkspace } from 'types/workspace.types';
import useWorkspaceDetails from 'hooks/useWorkspaceDetails';
import usePeppolFilters from 'hooks/Peppol/usePeppolFilters';

export interface UseWorkspaceActionsReturn {
  switchWorkspace: (
    workspaceId: IWorkspace['_id'],
    workspaceName?: string,
  ) => void;
  selectWorkspace: (
    workspaceId: IWorkspace['_id'],
    queryParams?: string,
  ) => void;
}

/**
 * Hook for workspace actions like switching, creating etc
 * Handles cache invalidation
 */
export const useWorkspaceActions = (): UseWorkspaceActionsReturn => {
  const navigate = useCustomNavigate();
  const { setWorkspaceId } = useWorkspaceDetails();
  const selectWorkspace = (
    workspaceId: IWorkspace['_id'],
    queryParams?: string,
  ): void => {
    usePeppolFilters.getState().resetFilters();
    setWorkspaceId(workspaceId);

    const path = queryParams ? `/?${queryParams}` : '/';
    navigate(path, { asDefault: true, replace: true });
  };

  const switchWorkspace = (
    workspaceId: IWorkspace['_id'],
    workspaceName?: string,
  ): void => {
    selectWorkspace(workspaceId);

    showToast(
      {
        title: `Successfully switched to workspace ${workspaceName || ''}`,
      },
      { type: 'success' },
    );
  };

  return {
    switchWorkspace,
    selectWorkspace,
  };
};
